export enum UserUploadFileTypeId {
  VIP = 1,
  ExclusiveAgent = 2,
  IndependentAgent = 3,
  FieldLeader = 4,
  FieldVicePresident = 5,
  EnrollTrackUser = 6,
}
